import React, {useState, useEffect} from 'react'

import classes from './ActivityTitle.module.css'
import Media from '../../Media/Media';
import clsx from 'clsx';
import { TYPES } from 'react-sdk/activities/ActivitiesConverter';
import Texts from 'react-sdk/Texts';

const ActivityTitle = ({activity, showMedia=true}) => {

  let type = activity.Type.toLowerCase()
  return (
    <div className={classes.ActivityTitle}>
      <div className={classes.icon}>
        <img src={`data/images/activity_icons/${type}.png`} alt={"icon " + type} />
        <div className={classes.type}>
          {Texts.get("activity_type_"+type)}
        </div>
      </div>
      {showMedia && activity.media &&
      <div className={classes.media}>
        <Media path={activity.media } key={activity.ID}/>
      </div>}
      <div className={clsx(classes.title, showMedia && activity.media && classes.withMedia)} dangerouslySetInnerHTML={{__html: activity.Text}} />
    </div>
  );
};

export default ActivityTitle;
